import * as THREE from 'three';
import { LODToaster } from './LODToaster';
import { UpdatePriority } from './DynamicObject';

/**
 * Small toaster - dog sized and quick moving
 */
export class LODToasterSmall extends LODToaster {
  constructor() {
    // Create with small toaster specific configuration
    // Dog-sized and high speed
    super(
      'LODToasterSmall', 
      new THREE.Vector3(0.5, 0.5, 0.5),  // 0.5 meters in size (dog-sized)
      2.0  // Fastest movement speed
    );
    
    // The SpatialManager will dynamically adjust priority based on distance and visibility
  }
  
  /**
   * Override health initialization for small toasters
   * Small toasters have less health but move faster
   */
  protected override initializeHealth(): void {
    // Small toasters have 50 health
    this.maxHealth = 50;
    this.currentHealth = this.maxHealth;
    
    console.log(`Initialized small toaster ${this.getId()} with ${this.maxHealth} health`);
  }
} 